<app-left-menu [showMenu]=false></app-left-menu>
<div id="main-container">

    <app-header [showHistoryButton]="true" [title]="title" [showAddCounselorButton]=true></app-header>

    <div class="content-header" style="margin-top: 70px;"></div>
    <div class="pharse"
    style="text-align: center;padding-bottom: 10px;font-style:italic">
    {{'Counselor.Pharse'|translate}}</div>
    <div class="page-content">

        <div class="tab-content">
        

                <!--<div id="{{(year.FullDate | date:'MM') +'_'+(year.FullDate | date:'y')}}"></div>-->

                <table *ngIf="counselors?.length>0" class="table table-bordered" id="table">
                    <thead>
                        <tr>
                            <th> {{'Common.FirstName' |translate}}</th>
                            <th> {{'Common.LastName' | translate}}

                            </th>
                            <th> {{'Counselor.Table.Header.License' | translate}}
                                
                            </th>
                            <th style="text-align: center;"> {{'Common.Action'| translate}}</th>

                        </tr>
                    </thead>
                    <tbody>

                        <tr id="tr{{item.CounselorId}}" [class.alternate]="i%2!=0" *ngFor="let item of counselors; index as i;">

                            <td>{{item.FirstName}}</td>
                            <td>{{item.LastName}}</td>
                            <td>
                              
                                {{item.Licenses}}

                            </td>


                            <td style="width: 100px;text-align: center;">
                                <a style="margin-right:10px"
                                    [routerLink]="['/managepractice/counselors/edit',item.CounselorId]"
                                    routerLinkActive="router-link-active" class="icon edit round"
                                    href="javascript:void(0)"></a>
                                    <a (click)="deleteCounselor(item.CounselorId)"
                                    class="icon delete round"
                                    href="javascript:void(0)"></a>
                                
                                </td>
                        </tr>
                    </tbody>
                </table>
                <div class="not-found" *ngIf="counselors?.length<=0">{{'Counselor.NoRecord'|translate}}
                </div>

        

        </div>

    </div>

</div>